export default __webpack_public_path__ + "static/media/PNJ-sport.63b1133b.png";